// *******************************************************************************
// Add class to body after some scroll
// *******************************************************************************
function addScrollingClass() {
  const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffset > 20);
}

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();
      ticking = false;
    });
    ticking = true;
  }
});

let lastScrollTop = 0;
window.addEventListener(
  'scroll',
  () => {
    const isScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.toggle('is-scrolled-up', isScrolledTop < lastScrollTop);
    lastScrollTop = isScrolledTop <= 0 ? 0 : isScrolledTop;

    if (windowWidth() > breakpointMd) {
      document.querySelectorAll('.menu__item.is-open-submenu').forEach((item) => toggleSubMenuClass(item, false));
      document.querySelector('.language-switch.is-open')?.classList.remove('is-open');
    }
  },
  false,
);

// *******************************************************************************
// Toggle header classes
// *******************************************************************************

const toggleMenuClass = (toggle) => {
  document.body.classList.toggle('is-open-menu', toggle);
  toggleBodyScrollLock(toggle);
};

attachEvent('.hamburger', 'click', () => {
  toggleMenuClass();
});

attachEvent('[data-close-menu]', 'click', () => {
  toggleMenuClass(false);
});

// *******************************************************************************
// Background Shader Scene
// *******************************************************************************

const headerBackground = document.querySelector('.site-header__background');

if (headerBackground) {
  const renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: true,
    powerPreference: 'high-performance',
    depth: false,
    stencil: false,
  });

  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.outputColorSpace = THREE.SRGBColorSpace;

  const canvas = renderer.domElement;
  canvas.classList.add('background-canvas');

  Object.assign(canvas.style, {
    position: 'fixed',
    inset: '0',
    zIndex: '-1',
    pointerEvents: 'none',
  });

  document.body.appendChild(canvas);

  // Fallback background
  document.documentElement.style.background = '#f2f1ff';
  document.body.style.background = '#f2f1ff';

  // ---------- Scene / Camera
  const scene = new THREE.Scene();

  const camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.01, 100);
  camera.position.set(0, 0, 1.6);

  // ---------- Geometry (mobile-aware)
  const isMobile = window.innerWidth < 768;
  const segments = isMobile ? 240 : 360;

  const geometry = new THREE.PlaneGeometry(2.8, 2.8, segments, segments);

  // ---------- Material
  const material = new THREE.ShaderMaterial({
    transparent: true,
    side: THREE.DoubleSide,
    dithering: true,
    uniforms: {
      uTime: { value: 0 },
      uResolution: { value: new THREE.Vector2(window.innerWidth, window.innerHeight) },
      uFade: { value: 0.0 },

      uAmp: { value: 0.26 },
      uFreq: { value: 2.2 },
      uSpeed: { value: 0.35 },

      uMinH: { value: -0.22 },
      uMaxH: { value: 0.22 },

      uPeakBias: { value: 2.9 },
      uDriftStrength: { value: 0.06 },
    },

    vertexShader: /* glsl */ `
    precision highp float;

    uniform float uTime;
    uniform float uAmp;
    uniform float uFreq;
    uniform float uSpeed;

    varying vec2 vUv;
    varying float vHeight;
    varying float vWave;

    void main() {
      vUv = uv;

      vec3 pos = position;
      float t = uTime * uSpeed;

      float w1 = sin(pos.x * uFreq + t);
      float w2 = cos(pos.y * (uFreq * 1.35) - t * 1.15);
      float w3 = sin((pos.x + pos.y) * (uFreq * 0.85) + t * 0.75);
      float w4 = cos((pos.x - pos.y) * (uFreq * 0.70) - t * 0.55);

      float wave = (w1 * 0.42 + w2 * 0.33 + w3 * 0.22 + w4 * 0.18);

      pos.z += wave * uAmp;

      vHeight = pos.z;
      vWave = wave;

      gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
    }
  `,

    fragmentShader: /* glsl */ `
    precision highp float;

    uniform float uTime;
    uniform vec2 uResolution;
    uniform float uFade;
    uniform float uMinH;
    uniform float uMaxH;
    uniform float uPeakBias;
    uniform float uDriftStrength;

    varying vec2 vUv;
    varying float vHeight;
    varying float vWave;

    float hash21(vec2 p) {
      p = fract(p * vec2(123.34, 456.21));
      p += dot(p, p + 34.345);
      return fract(p.x * p.y);
    }

    float vnoise(vec2 p) {
      vec2 i = floor(p);
      vec2 f = fract(p);
      vec2 u = f * f * (3.0 - 2.0 * f);

      float a = hash21(i);
      float b = hash21(i + vec2(1.0, 0.0));
      float c = hash21(i + vec2(0.0, 1.0));
      float d = hash21(i + vec2(1.0, 1.0));

      return mix(mix(a, b, u.x), mix(c, d, u.x), u.y);
    }

    vec3 palette(float t, vec3 base, vec3 c1, vec3 c2, vec3 c3) {
      float t1 = smoothstep(0.00, 0.50, t);
      float t2 = smoothstep(0.30, 0.80, t);
      float t3 = smoothstep(0.60, 1.00, t);

      vec3 col = mix(base, c1, t1);
      col = mix(col, c2, t2);
      col = mix(col, c3, t3);
      return col;
    }

    void main() {
      vec3 base = vec3(0.933, 0.965, 0.961);
      vec3 c1   = vec3(0.647, 0.859, 0.886);
      vec3 c2   = vec3(0.549, 0.800, 0.820);
      vec3 c3   = vec3(0.420, 0.718, 0.741);

      float h = clamp((vHeight - uMinH) / (uMaxH - uMinH), 0.0, 1.0);
      float hc = pow(h, uPeakBias);

      float n = vnoise(vUv * 3.2 + vec2(uTime * 0.03, -uTime * 0.02));
      hc = clamp(hc + (n - 0.5) * uDriftStrength, 0.0, 1.0);

      vec2 p = vUv - 0.5;
      p.x *= uResolution.x / uResolution.y;
      float vign = smoothstep(0.90, 0.20, length(p));
      hc *= vign;

      vec3 col = palette(hc, base, c1, c2, c3);
      col += vWave * 0.02;

      col = mix(base, col, uFade);
      gl_FragColor = vec4(col, uFade);
    }
  `,
  });

  // ---------- Mesh
  const mesh = new THREE.Mesh(geometry, material);
  scene.add(mesh);

  // Cache uniforms
  const { uniforms } = material;

  // ---------- Scroll → Fade
  const updateFadeFromScroll = () => {
    const y = window.scrollY || 0;
    const vh = window.innerHeight;

    const fadeStartPx = 0.5 * vh;
    const fadeLengthPx = 1.0 * vh;

    const t = (y - fadeStartPx) / fadeLengthPx;
    uniforms.uFade.value = THREE.MathUtils.clamp(1.0 - THREE.MathUtils.smoothstep(t, 0.0, 1.0), 0.0, 1.0);
  };

  window.addEventListener('scroll', updateFadeFromScroll, { passive: true });
  updateFadeFromScroll();

  // ---------- Resize (debounced)
  const onResize = debounce(() => {
    const w = window.innerWidth;
    const h = window.innerHeight;

    camera.aspect = w / h;
    camera.updateProjectionMatrix();

    renderer.setSize(w, h);
    uniforms.uResolution.value.set(w, h);
  }, 150);

  window.addEventListener('resize', onResize);

  // ---------- Animate
  const clock = new THREE.Clock();

  const animateBackground = () => {
    uniforms.uTime.value = clock.getElapsedTime();
    renderer.render(scene, camera);
    requestAnimationFrame(animateBackground);
  };

  animateBackground();

  // ---------- Initial fade-in (one-time)
  const FADE_IN_DURATION = 1.2; // seconds
  const fadeStart = performance.now();

  const fadeIn = () => {
    const t = (performance.now() - fadeStart) / (FADE_IN_DURATION * 1000);
    uniforms.uFade.value = THREE.MathUtils.clamp(THREE.MathUtils.smoothstep(t, 0, 1), 0, 1);

    if (t < 1) requestAnimationFrame(fadeIn);
  };

  fadeIn();
}
